// Audio Play-Pause With Progress (Play One At A time)
var currentAudioWithProgress = null; // Keep track of the currently playing audio

document.querySelectorAll('.custom-audio-player-wrapper-with-progressbar').forEach(playerwithprogress => {
  const audioWithProgress = playerwithprogress.querySelector('audio');
  const playBtnWithProgress = playerwithprogress.querySelector('.play-btn');
  const progressBar = playerwithprogress.querySelector('.progress');

  // Play / Pause button click logic
  playBtnWithProgress.addEventListener('click', () => {
    if (audioWithProgress.paused) {
      // Pause the currently playing audio if any
      if (currentAudioWithProgress && currentAudioWithProgress !== audioWithProgress) {
        currentAudioWithProgress.pause();
        currentAudioWithProgress.closest('.custom-audio-player-wrapper-with-progressbar').querySelector('.play-btn').innerHTML = `
          <svg class="play_button" width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0691 7.83155C17.5325 8.07797 17.9201 8.44581 18.1904 8.89568C18.4607 9.34555 18.6035 9.86048 18.6035 10.3853C18.6035 10.9101 18.4607 11.425 18.1904 11.8749C17.9201 12.3248 17.5325 12.6926 17.0691 12.939L4.70848 19.6606C2.71816 20.744 0.273438 19.3355 0.273438 17.1078V3.66375C0.273438 1.43513 2.71816 0.0275308 4.70848 1.10904L17.0691 7.83155Z" fill="white"/>
          </svg>`;
      }

      // Play the selected audio
      audioWithProgress.play();
      playBtnWithProgress.innerHTML = `
        <svg class="pause_button" width="20" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 7H8V17H11V7Z" fill="#FFFFFF"/>
          <path d="M13 17H16V7H13V17Z" fill="#FFFFFF"/>
        </svg>`;
      currentAudioWithProgress = audioWithProgress;
    } else {
      audioWithProgress.pause();
      playBtnWithProgress.innerHTML = `
        <svg class="play_button" width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.0691 7.83155C17.5325 8.07797 17.9201 8.44581 18.1904 8.89568C18.4607 9.34555 18.6035 9.86048 18.6035 10.3853C18.6035 10.9101 18.4607 11.425 18.1904 11.8749C17.9201 12.3248 17.5325 12.6926 17.0691 12.939L4.70848 19.6606C2.71816 20.744 0.273438 19.3355 0.273438 17.1078V3.66375C0.273438 1.43513 2.71816 0.0275308 4.70848 1.10904L17.0691 7.83155Z" fill="white"/>
        </svg>`;
      currentAudioWithProgress = null;
    }
  });

  // Update progress bar
  audioWithProgress.addEventListener('timeupdate', () => {
    const percentage = (audioWithProgress.currentTime / audioWithProgress.duration) * 100;
    progressBar.style.width = `${percentage}%`;
  });

  // Reset button when audio ends
  audioWithProgress.addEventListener('ended', () => {
    playBtnWithProgress.innerHTML = `
      <svg class="play_button" width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.0691 7.83155C17.5325 8.07797 17.9201 8.44581 18.1904 8.89568C18.4607 9.34555 18.6035 9.86048 18.6035 10.3853C18.6035 10.9101 18.4607 11.425 18.1904 11.8749C17.9201 12.3248 17.5325 12.6926 17.0691 12.939L4.70848 19.6606C2.71816 20.744 0.273438 19.3355 0.273438 17.1078V3.66375C0.273438 1.43513 2.71816 0.0275308 4.70848 1.10904L17.0691 7.83155Z" fill="white"/>
      </svg>`;
    currentAudioWithProgress = null;
  });

  // ✅ Pause audio when section goes out of view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && !audioWithProgress.paused) {
        audioWithProgress.pause();
        playBtnWithProgress.innerHTML = `
          <svg class="play_button" width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0691 7.83155C17.5325 8.07797 17.9201 8.44581 18.1904 8.89568C18.4607 9.34555 18.6035 9.86048 18.6035 10.3853C18.6035 10.9101 18.4607 11.425 18.1904 11.8749C17.9201 12.3248 17.5325 12.6926 17.0691 12.939L4.70848 19.6606C2.71816 20.744 0.273438 19.3355 0.273438 17.1078V3.66375C0.273438 1.43513 2.71816 0.0275308 4.70848 1.10904L17.0691 7.83155Z" fill="white"/>
          </svg>`;
        if (currentAudioWithProgress === audioWithProgress) {
          currentAudioWithProgress = null;
        }
      }
    });
  }, { threshold: 0.1 }); // Trigger when 10% of section is visible

  observer.observe(playerwithprogress);
});


// PDP metafield Song sample and story sample

document.addEventListener("DOMContentLoaded", () => {
  let currentlyPlayingAudio = null; // Keeps track of the currently playing audio

  document.querySelectorAll(".metafield-song-item .audio").forEach(audioDiv => {
    const audioPath = audioDiv.getAttribute("data-audio");
    const audioElement = new Audio(audioPath);

    audioDiv.addEventListener("click", () => {
      // If there is an audio playing, pause it and reset its icon
      if (currentlyPlayingAudio && currentlyPlayingAudio !== audioElement) {
        currentlyPlayingAudio.pause();
        const previousAudioDiv = document.querySelector(
          `.audio[data-audio="${currentlyPlayingAudio.src}"]`
        );
        if (previousAudioDiv) {
          previousAudioDiv.querySelector("i").classList.remove("pause-icon");
          previousAudioDiv.querySelector("i").classList.add("play-icon");
        }
      }

      // Toggle play/pause for the clicked audio
      if (audioElement.paused) {
        audioElement.play();
        currentlyPlayingAudio = audioElement;
        audioDiv.querySelector("i").classList.remove("play-icon");
        audioDiv.querySelector("i").classList.add("pause-icon");
      } else {
        audioElement.pause();
        audioDiv.querySelector("i").classList.remove("pause-icon");
        audioDiv.querySelector("i").classList.add("play-icon");
        currentlyPlayingAudio = null;
      }
    });

    // Reset the icon when the audio ends
    audioElement.addEventListener("ended", () => {
      audioDiv.querySelector("i").classList.remove("pause-icon");
      audioDiv.querySelector("i").classList.add("play-icon");
      currentlyPlayingAudio = null;
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const iconPlus = header.querySelector('.icon-plus');
      const iconMinus = header.querySelector('.icon-minus');

      // Toggle the accordion content and icon visibility
      content.classList.toggle('active');
      iconPlus.style.display = content.classList.contains('active') ? 'none' : 'block';
      iconMinus.style.display = content.classList.contains('active') ? 'block' : 'none';
    });
  });
});